export default __webpack_public_path__ + "static/media/logoecosfron.6f31d0c9.svg";